"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const products = ["Underground mining equipment", "Crushers", "Pumps", "LED lighting systems", "Switchboards"];
export default function ProductRange() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}